import React from "react";
import { formatNumber } from "../../utils/methods";
import ElipsisText from "../ElipsisText";
import clsx from "clsx";

type Variant = "primary" | "secondary" | "danger" | "success" | "warning" | "info" | "";

interface CardProps {
  wrapperClassName?: string;
  title: string;
  value: number | string;
  description: string;
  icon: string;
  variant?: Variant;
  background?: boolean;
  compact?: boolean;
}

const Card: React.FC<CardProps> = ({
  wrapperClassName = "",
  title,
  value,
  description,
  icon,
  variant = "primary",
  background,
  compact,
}) => {
  return (
    <div className={wrapperClassName}>
      <div className={clsx('card', background && `bg-label-${variant}`)}>
        <div className={clsx('card-body', compact && 'p-3')}>
          <div className="d-flex justify-content-between align-items-start">
            <div className="me-1">
              <p className="text-heading mb-1">{title}</p>
              <div className="d-flex align-items-center">
                <h4 className="mb-1 me-2">{formatNumber(value)}</h4>
              </div>
            </div>
            <div className="avatar pe-none">
              <div className={`avatar-initial bg-label-${variant} rounded-3`}>
                <div className={icon} />
              </div>
            </div>
          </div>
          {!compact && (
            <div className="mt-1">
              <ElipsisText text={description} width="90%" className="text-muted small" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Card;